
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { PackageItem } from "@/types/package-item";

interface PackageInclusionCardProps {
  item: PackageItem;
  onEdit: () => void;
  onDelete: () => void;
}

export const PackageInclusionCard = ({ item, onEdit, onDelete }: PackageInclusionCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="leading-relaxed">{item.text_ar}</CardTitle>
        <CardDescription className="text-left" dir="ltr">{item.text_en}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-2 justify-end">
          <Button
            variant="ghost"
            size="sm"
            onClick={onEdit}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDelete}
            className="text-red-600 hover:text-red-700"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
